import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";

export const sentimentVeryDissatisfied = (props) => {
  return <SentimentVeryDissatisfiedIcon {...props} />;
};
